import React, {useState, useEffect, useRef} from "react";
import {FilterPanel} from "./FilterPanel";
import {PopUp} from "./PopUp";
import {Header} from "./Header";
import {Footer} from "./Footer";
import {UserDetails} from "./UserDetails";
import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated} from "@azure/msal-react";
import {loginRequest} from ".././authConfig";
import {callMsGraph, callMsGraphProfilePicture, callMsGraphMemberOf} from "../services/graph";
import configData from ".././config.json"
import {PositionMarkerApiRequest, PositionMarkerItem} from "../models/PositionMarkerModel";
import {getAPIPositionMarkerDetail, getAPIPositionMarkerFilter} from "../services/PositionMarkerAPI";
import BlackDot from './../assets/black-dot.png';
import {AccordionButton, Modal} from "react-bootstrap";
import {ClipLoader} from "react-spinners";
import Spinner from 'react-bootstrap/Spinner'
import {DoorOpenFill} from "react-bootstrap-icons";
import Accordion from "react-bootstrap/Accordion";
import {Multiselect} from "multiselect-react-dropdown";


export interface TablePositionMarkerDetail {
    clienteDes : string;
    clienteFattDes : string;
    famigliaCommercialeDes : string;
    tipologiaCommercialeId : string;
    qtaFN_AC : number;
    qtaFN_AP : number;
    qtaVarAnno : number;
    qtaVarPerc : number;
    qtaFN_AT : number;
    valoreFN_AC : number;
    valoreFN_AP : number;
    valoreVarAnno : number;
    valoreVarPerc : number;
    valoreFN_AT : number;
}

export interface ColumnGroup {
    header: string | null;
    columns: Column[];
}

export interface Column {
    header: string;
    accessor: keyof TablePositionMarkerDetail;
}

interface TableProps {
    data: TablePositionMarkerDetail[];
    columnGroups: ColumnGroup[];
}

export interface GraphMemberOf{
    id: string
}


///Questo componente contiene la logica vera e propria dell'applicativo, racchiude tutti i componenti secondari al suo interno
///NB: Valutare se separare i componenti Header & Footer?

export const MapsManagement: React.FC = () => {
    const [showpopupuser, setShowPopUpUser] = useState(false);
    const [showerror, setShowError] = useState(false);
    const {instance, accounts} = useMsal();
    const [graphDataMyProfile, setGraphDataMyProfile] = useState(null);
    const [profilepicture, setProfilePicture] = useState("");
    const isAuthenticated = useIsAuthenticated();
    const [showModal, setShowModal] = useState(false);
    const [defaultCenter, setCenter] = useState({ lat: 150, lng: 150 });
    const [positionTrakerDetail, setPositionTrakerDetail] = useState<TablePositionMarkerDetail[]>([]);
    const [positionTrakerDetailTotalRow, setPositionTrakerDetailTotalRow] = useState<TablePositionMarkerDetail[]>([]);
    const [positionTrakerDetailTotal, setPositionTrakerDetailTotal] = useState<TablePositionMarkerDetail>();
    const [graphDataMyGroups, setgraphDataMyGroups] = useState([] as GraphMemberOf[]); //servono??
    const [titleModal, setModalTitle] = useState<string>('Hello, World!');
    const [isLoading, setIsLoading] = useState(false);
    const [countSalesType1, setSalesType1] = useState(0);
    const [countSalesType2, setSalesType2] = useState(0);
    const [countSalesType3, setSalesType3] = useState(0);
    const [countSalesType4, setSalesType4] = useState(0);
    const [countSalesType5, setSalesType5] = useState(0);
    const [countSalesTotal, setSalesTotal] = useState(0);
    const [showriepilogo, setShowRiepilogo] = useState(false);

    
    const columnGroups: ColumnGroup[] = [
        {
            header: '',
            columns: [
                { header: 'Famiglia Commerciale', accessor: 'famigliaCommercialeDes' },
                { header: 'Tipologia Commerciale', accessor: 'tipologiaCommercialeId' }
            ],
        },
        {
            header: 'Quantità',
            columns: [
                { header: 'AC', accessor: 'qtaFN_AC' },
                { header: 'AP', accessor: 'qtaFN_AP' },
                { header: 'Var Anno', accessor: 'qtaVarAnno' },
                { header: 'Var %', accessor: 'qtaVarPerc' },
                { header: 'AT', accessor: 'qtaFN_AT' },
            ],
        },
        {
            header: 'Valore',
            columns: [
                { header: 'AC', accessor: 'valoreFN_AC' },
                { header: 'AP', accessor: 'valoreFN_AP' },
                { header: 'Var Anno', accessor: 'valoreVarAnno' },
                { header: 'Var %', accessor: 'valoreVarPerc' },
                { header: 'AT', accessor: 'valoreFN_AT' },
            ],
        },
    ];

    const formatNumber = (value : any) => {
        if (typeof value === 'number') {
            const formatter = new Intl.NumberFormat('it-IT', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return formatter.format(value);
        }
        return value;
    };


    let positionTraker : PositionMarkerItem[] = [];
    
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {

        const script = document.createElement('script');
        script.innerHTML = `(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.\${c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})
     ({key: "${configData.MAP_API_KEY}", v: "weekly"});`;
        document.head.appendChild(script);
        setCurrentPositionInMap(null,null);
    }, [isAuthenticated]);

    function setCurrentPositionInMap(positionMarkers: PositionMarkerItem[] | null, filter: PositionMarkerApiRequest| null){
        navigator.geolocation.getCurrentPosition(
            (position) => {
                
                const { latitude, longitude } = position.coords;
                
                if(positionMarkers?.length == 0 || positionMarkers == null)
                    setCenter({ lat: latitude, lng: longitude });
                
                initMap(positionMarkers, latitude, longitude,filter);
            },
            (error) => {
                console.error("Error getting the current position:", error);
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        );
    }

    //FILTRO SUI DATI RECUPERATI DALL'API
    const filterSubmit = async (filter: PositionMarkerApiRequest) => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {

                const {latitude, longitude} = position.coords;

                filter.currentLat = latitude.toString() ?? "0";
                filter.currentLng = longitude.toString() ?? "0";

                setIsLoading(true);
                const positionMarkerResult = await getAPIPositionMarkerFilter(filter);

                if (positionMarkerResult) {
                    //setPositionTraker(positionMarkerResult.data);
                    positionTraker = positionMarkerResult.data;
                    setCurrentPositionInMap(positionMarkerResult.data, filter);
                    setIsLoading(false);
                }
                setIsLoading(false);
            });
    };

    //FINE FILTRO SUI DATI RECUPERATI DALL'API

    //OPERAZIONI MSAL & MICROSOFT GRAPH

    const userLogin = () => {
        instance.loginRedirect(loginRequest)
            .then(result => {
                setCurrentPositionInMap(null,null);
            })
            .catch(e => {
                console.log(e);
            });
    }
    const userLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }
    
    const RequestProfileData = () => {
        if (navigator.onLine) {
            // Silently acquires an access token which is then attached to a request for MS Graph data
            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                callMsGraph(response.accessToken).then(response => setGraphDataMyProfile(response)).catch(err => console.error("Errore - RequestProfileData - /me : " + err));
            })


            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                callMsGraphProfilePicture(response.accessToken).then(response => () => {
                    const url = window.URL || window.webkitURL;
                    const blobUrl = URL.createObjectURL(response.data);
                    setProfilePicture(response.data)
                    setCurrentPositionInMap(null,null);
                }).catch(err => console.error("Errore - RequestProfileData - /me/photo/$value: " + err));
            })

            setShowPopUpUser(true);
        }
    }


    //FINE OPERAZIONI MSAL & MICROSOFT GRAPH

    //METODI PER LA CHIUSURA DEI POP-UP
    
    const closeClickUser = () => {
        setShowPopUpUser(false);
    };

    //FINE METODI PER LA CHIUSURA DEI POP-UP          

    

    //Inizio metodi mappa

    let map2: google.maps.Map;
    let streetViewService;
    let lastOpenedInfoWindow: google.maps.InfoWindow | null = null;

    const currentLocationIcon = {
        path: "https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png",
        fillColor: '#4285F4',
        fillOpacity: 1,
        scale: 6,
        strokeColor: '#ffffff',
        strokeWeight: 2,
    };

    async function initMap(positionMarkers: PositionMarkerItem[] | null, lat : number, lng : number, filter: PositionMarkerApiRequest | null ): Promise<void> {
        const {Map} = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        
        let countSalesType1 = 0;
        let countSalesType2 = 0;
        let countSalesType3 = 0;
        let countSalesType4 = 0;
        let countSalesType5 = 0;
        
        let latCenter = 0;
        let lngCenter = 0;
        if(positionMarkers != null){
            //Se presenti marker, centro con il primo marker presente:
            if(positionMarkers.length > 0){
                let pos = {
                    lat: Number(positionMarkers[0].lat),
                    lng: Number(positionMarkers[0].lng)
                }

                setCenter({ lat: pos.lat, lng: pos.lng });
                latCenter = pos.lat;
                lngCenter = pos.lng;
            }
        }
        
        if(latCenter == 0)
            latCenter = lat;

        if(lngCenter == 0)
            lngCenter = lng;

        map2 = new Map(document.getElementById("map") as HTMLElement, {
            center: {lat: latCenter ?? lat, lng: lngCenter ?? lng},
            zoom: 8,
            mapId: configData.MAP_ID
        });

        const location = { lat, lng };

        const currentPosIcon = document.createElement("div");
        currentPosIcon.style.width = "20px";
        currentPosIcon.style.height = "20px";
        currentPosIcon.style.backgroundColor = "#4285F4"; // Colore blu
        currentPosIcon.style.borderRadius = "50%"; // Arrotonda i bordi per creare un cerchio
        currentPosIcon.style.border = "2px solid white"; // Bordo bianco per somigliare all'icona di Google Maps
        currentPosIcon.style.boxShadow = "0 0 5px rgba(0, 0, 0, 0.3)"; // Aggiunge un'ombra per profondità
        
        const marker = new AdvancedMarkerElement({
            position: location,
            map: map2,
            content: currentPosIcon
        });

        if(positionMarkers == null)
            return;
        
        for (let i = 0; i < positionMarkers.length; i++) {

            let pTraker = positionMarkers[i];
            const iconImage = document.createElement("img");
            switch (pTraker.salesTypeId){
                case 1 :
                    iconImage.src = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                    countSalesType1++;
                    break;
                case 2 :
                    iconImage.src = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
                    countSalesType2++;
                    break;
                case 3:
                    iconImage.src = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                    countSalesType3++;
                    break;
                case 4:     
                    iconImage.src = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
                    countSalesType4++;
                    break;
                case 5 :
                    iconImage.src = BlackDot;
                    iconImage.height = 30;
                    iconImage.width = 17;
                    countSalesType5++;
                    break;
            }

            let pos = {
                lat: Number(pTraker.lat),
                lng: Number(pTraker.lng)
            }

            const marker = new AdvancedMarkerElement({
                map: map2,
                position: pos,
                title: pTraker.title,
                content: iconImage
            });

            const contentString =
                '<div id="content" style="min-height: 100pt;">' +
                '<div id="siteNotice">' +
                "</div>" +
                '<div class="d-flex w-full">' +
                '<div class="col-1">'+
                iconImage.outerHTML +
                '</div>'+
                '<div class="col-11 flex-wrap">' +
                '<h3 id="firstHeading" class="firstHeading">' + pTraker.title + '</h3>' +
                '</div>'+
                '</div>'+
                '<div style="display: flex; width: 100%">' +
                '<h6 id="secondHeading" class="secondHeading" style="margin-right: 10px">' + pTraker.localitaId + '</h6>' +
                '<h6 id="thirdHeading" class="thirdHeading">' + pTraker.provinciaId + '</h6>' +
                '</div>'+
                '<div style="width: 100%">' +
                '<h6 style="margin-right: 10px">' + pTraker.canaleDes + '</h6>' +
                '<h6>' + pTraker.agenteDes + '</h6>' +
                '</div>'+
                '<div style="width: 100%">' +
                '<h6 style="margin-right: 10px"> Fatturato AC: ' + formatNumber(pTraker.valoreFN_AC) + ' €</h6> ' +
                '<h6> Fatturato AP: ' + formatNumber(pTraker.valoreFN_AP) + ' €</h6>' +
                '</div>'+
                '<div id="bodyContent">' +
                '<div class="d-flex d-inline-flex justify-content-center w-100">' +
                '<button class="btn btn-secondary btn-lg mr-1 marker-btn" style="max-width: 100pt" id="marker' + i + '">' +
                '<i class="fas fa-street-view" style="width: 100%"></i> Street View' +
                '</button>' +
                '<button class="btn btn-secondary btn-lg ml-1 detail-btn" style="max-width: 100pt" id="detail' + i + '">' +
                '<i class="fas fa-info-circle" style="width: 100%"></i> Dettaglio' +
                '</button>' +
                '</div>' +
                "</div>" +
                "</div>";

            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });

            marker.addListener("click", () => {
                if (lastOpenedInfoWindow) {
                    lastOpenedInfoWindow.close();
                }

                // Apre il nuovo InfoWindow e lo memorizza
                infowindow.open(marker.map, marker);
                lastOpenedInfoWindow = infowindow;
                setTimeout(() => {
                    const streetViewBtn = document.getElementById('marker' + i);
                    if (streetViewBtn) {
                        // Aggiunge un event listener per il clic sull'elemento
                        streetViewBtn.addEventListener('click', () => {
                            showStreetView(pTraker);
                        });
                    }

                    const detailBtn = document.getElementById('detail' + i);
                    if (detailBtn) {
                        // Aggiunge un event listener per il clic sull'elemento
                        detailBtn.addEventListener('click', async () => {
                            //showStreetView(pTraker);
                            setIsLoading(true);
                            let _year:number | undefined = 0
                            if(filter && filter.year != undefined){_year = filter.year}
                            const positionMarkerResult = await getAPIPositionMarkerDetail(pTraker.id, _year);
                            if (positionMarkerResult) {
                                setPositionTrakerDetail(positionMarkerResult.data.listaDettaglio);
                                setPositionTrakerDetailTotal(positionMarkerResult.data.totali);
                                setPositionTrakerDetailTotalRow(positionMarkerResult.data.listaTotali); 
                                //setModalTitle(positionTraker[i].title);
                                setModalTitle(positionMarkerResult.data.listaDettaglio[0].clienteFattDes);
                                handleOpenModal();
                                setIsLoading(false);
                            }

                            setIsLoading(false);
                        });
                    }
                    
                }, 1000);

            });
        }
        
        setSalesType1(countSalesType1);
        setSalesType2(countSalesType2);
        setSalesType3(countSalesType3);
        setSalesType4(countSalesType4);
        setSalesType5(countSalesType5);
        //setSalesTotal(positionMarkers.length);

        var totalCount =
            (countSalesType1 ?? 0) +
            (countSalesType2 ?? 0) +
            (countSalesType3 ?? 0) +
            (countSalesType4 ?? 0) +
            (countSalesType5 ?? 0);

        setSalesTotal(totalCount);
        
        setShowRiepilogo(true);
    }

    function backToInitMap() {
        map2.setStreetView(null); // Rimuove la Street View dalla mappa
        const backToMap = document.getElementById('backToMap');
        if (backToMap != null) {
            backToMap.style.display = 'none';
            setShowRiepilogo(true);
        }
    }

    function showStreetView(position : any) {        
        streetViewService = new google.maps.StreetViewService();
        const center = map2.getCenter();

        let pos = {
            lat: Number(position.lat),
            lng: Number(position.lng)
        }
        
        streetViewService.getPanorama({ location: pos, radius: 50, source: google.maps.StreetViewSource.OUTDOOR  }, data => {
            if (data && data.location) {
                const mapElement = document.getElementById("map");
                if (mapElement) {
                    //Rendo visibile il pulsante torna alla mappa
                    const backToMap = document.getElementById('backToMap');
                    if(backToMap != null){
                        backToMap.addEventListener('click', () => {
                            backToInitMap();
                        });

                        backToMap.style.display = 'block';
                        setShowRiepilogo(false);
                    }
                    
                    const panorama = new google.maps.StreetViewPanorama(
                        mapElement,
                        { position: data.location.latLng }
                    );
                    panorama.setPano(data.location.pano);
                    panorama.setPov({
                        heading: 270,
                        pitch: 0,
                    });
                    panorama.setVisible(true);

                    map2.setStreetView(panorama);
                } else {
                    alert("Steet view non disponibile in quest'area")
                }
            } else {
                alert("Steet view non disponibile in quest'area")
            }
        });
    }

    //FINE

    return (
        <>

            <header>
                <Header userdetailsHandler={RequestProfileData}
                        username={accounts.length > 0 ? accounts[0].name : ""}
                        isAuthenticated={isAuthenticated} loginHandler={userLogin}
                        logoutHandler={userLogout}></Header>
            </header>

            {isLoading && (
                <div className="spinner-container">
                    <Spinner animation="border" variant="primary"/>
                </div>
            )}

            <main className="flex-shrink-0">

                <div className="container-fluid">
                    <div className="row justify-content-center App-custommargintop-filters">
                        <AuthenticatedTemplate>
                            <FilterPanel submitForm={filterSubmit}></FilterPanel>

                            {showriepilogo  && (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    marginTop: '10px',
                                    position: "absolute",
                                    right: '0px',
                                    width: '50%'
                                }}>
                                    <Accordion defaultActiveKey="0" className="accordionClass">
                                        <Accordion.Item eventKey="0">
                                            <AccordionButton className="App-title">Riepilogo
                                            </AccordionButton>
                                            <Accordion.Body style={{maxHeight: '80vh', overflowY: 'auto'}}>
                                                <div className="w-100 riepilogoClassDiv">
                                                    <div className="w-100 d-flex flex-wrap">
                                                        <img style={{maxHeight: '30pt'}}
                                                             src={"https://maps.google.com/mapfiles/ms/icons/blue-dot.png"}/>
                                                        <label>Cliente Nuovo : {countSalesType1}</label>
                                                    </div>
                                                    <div className="w-100 d-flex flex-wrap mt-3">
                                                        <img style={{maxHeight: '30pt'}}
                                                             src={"https://maps.google.com/mapfiles/ms/icons/green-dot.png"}/>
                                                        <label>Positivo : {countSalesType2}</label>
                                                    </div>
                                                    <div className="w-100 d-flex flex-wrap mt-3">
                                                        <img style={{maxHeight: '30pt'}}
                                                             src={"https://maps.google.com/mapfiles/ms/icons/yellow-dot.png"}/>
                                                        <label>Minore Uguale 5% : {countSalesType3}</label>
                                                    </div>
                                                    <div className="w-100 d-flex flex-wrap mt-3">
                                                        <img style={{maxHeight: '30pt'}}
                                                             src={"https://maps.google.com/mapfiles/ms/icons/red-dot.png"}/>
                                                        <label>Negativo Maggiore 5% : {countSalesType4}</label>
                                                    </div>
                                                    <div className="w-100 d-flex flex-wrap mt-3">
                                                        <img height={30} width={17}
                                                             src={BlackDot}
                                                             style={{marginLeft: '5pt', marginRight: '5pt'}}/>
                                                        <label>Nessun acquisto pari periodo : {countSalesType5}</label>
                                                    </div>
                                                    <div className="w-100 d-flex flex-wrap mt-3">
                                                        Totale Clienti : {countSalesTotal}
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            )}

                            <div style={{width: '100%', minHeight: '50px'}}>
                                <button className="btn" id="backToMap" style={{
                                    maxWidth: '100px',
                                    float: 'right',
                                    marginTop: '10px',
                                    display: 'none',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    backgroundColor: 'white',
                                    color: 'block',
                                    fontWeight: 'bold'
                                }}>Torna alla Mappa
                                </button>
                            </div>
                        </AuthenticatedTemplate>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row justify-content-center App-custommargintop-elements">
                        <AuthenticatedTemplate>

                            <div id="map" style={{height: '79vh', width: '100vw'}}></div>

                            <Modal show={showModal} onHide={handleCloseModal} size="xl">
                                <Modal.Header closeButton>
                                    <Modal.Title>{titleModal} : Dettaglio</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="w-100 overflow-auto table-wrapper">
                                        <table className="table table-fixed-header">
                                            <thead>
                                            {/* Intestazioni raggruppate */}
                                            <tr className="sticky-header">
                                                {columnGroups.map((group, index) => (
                                                    <th key={index} colSpan={group.columns.length}>
                                                        {group.header}
                                                    </th>
                                                ))}
                                            </tr>
                                            {/* Intestazioni delle colonne */}
                                            <tr className="sticky-header second-row">
                                                {columnGroups.map((group, groupIndex) =>
                                                    group.columns.map((column, columnIndex) => (
                                                        <th key={`${groupIndex}-${columnIndex}`}>{column.header}</th>
                                                    ))
                                                )}
                                            </tr>
                                            </thead>
                                            <tbody style={{maxHeight: '40vh'}}>
                                            {positionTrakerDetail.map((item, rowIndex) => {
                                                const currentFamiglia = item.famigliaCommercialeDes;
                                                const nextFamiglia = positionTrakerDetail[rowIndex + 1]?.famigliaCommercialeDes;

                                                // Trova il totale corrispondente alla famiglia corrente
                                                const total = positionTrakerDetailTotalRow.find(total => total.famigliaCommercialeDes === currentFamiglia);

                                                return (
                                                    <React.Fragment key={rowIndex}>
                                                        {/* Riga dei dati */}
                                                        <tr>
                                                            {columnGroups.map((group, groupIndex) =>
                                                                group.columns.map((column, columnIndex) => (
                                                                    <td key={`${rowIndex}-${groupIndex}-${columnIndex}`}>
                                                                        {formatNumber(item[column.accessor])}
                                                                    </td>
                                                                ))
                                                            )}
                                                        </tr>

                                                        {/* Mostra il totale solo dopo l'ultima riga di questa famiglia */}
                                                        {currentFamiglia !== nextFamiglia && total && (
                                                            <tr className="total-row">
                                                                {columnGroups.map((group, groupIndex) =>
                                                                    group.columns.map((column, columnIndex) => {
                                                                        const value = total ? total[column.accessor] : 0; // Valore di fallback a 0
                                                                        return (
                                                                            <td key={`${rowIndex}-${groupIndex}-${columnIndex}`}
                                                                                className="total-row">
                                                                                {formatNumber(value)}
                                                                            </td>
                                                                        );
                                                                    })
                                                                )}
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}

                                            {/* Riga dei totali generali */}
                                            {positionTrakerDetailTotal != null && (
                                                <tr className="total-row-general">
                                                    {columnGroups.map((group, groupIndex) =>
                                                        group.columns.map((column, columnIndex) => (
                                                            <td
                                                                key={`${groupIndex}-${columnIndex}`}
                                                                className="total-row-general"
                                                            >
                                                                {columnIndex === 0 && groupIndex === 0 ? (
                                                                    // Prima colonna mostra il testo "Totale complessivo"
                                                                    'Totale complessivo'
                                                                ) : (
                                                                    formatNumber(positionTrakerDetailTotal[column.accessor])
                                                                )}
                                                            </td>
                                                        ))
                                                    )}
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary btn-lg ml-1 detail-btn"
                                            onClick={handleCloseModal}> Chiudi
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <div className="container-fluid">
                                <div className="row justify-content-center App-custommargintop">
                                <span className="text-center">
                                    <DoorOpenFill size={100}></DoorOpenFill>
                                    <br/><br/>
                                    <h6 className='d-block d-sm-none'>Please, Sign-In to the app</h6>
                                    <h4 className='d-none d-sm-block'>Please, Sign-In to the app</h4>
                                </span>
                                </div>
                            </div>
                        </UnauthenticatedTemplate>
                    </div>
                </div>
            </main>

            <footer className="App-footer mt-auto">
                <Footer></Footer>
            </footer>

            {showpopupuser && (
                <PopUp
                    title="User Details"
                    closeclick={closeClickUser}
                >
                    <UserDetails photo={profilepicture} signinHandler={userLogin} signoutHandler={userLogout}
                                 isAuthenticated={isAuthenticated} graphData={graphDataMyProfile}></UserDetails>
                </PopUp>
            )}

        </>
    );
}


